import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, take } from 'rxjs';
import { AccountService } from '../services/account.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private accountService:AccountService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    // List of URLs to exclude from the interceptor
    const excludedUrls = ['vimeo.com'];

    // Check if the request URL contains any of the excluded URLs
    const shouldExclude = excludedUrls.some(url => request.url.includes(url));

    if (shouldExclude) {
      // If the URL matches an excluded URL, proceed without modifying the headers
      return next.handle(request);
    }

    this.accountService.currentUser$.pipe(take(1)).subscribe(
      {next:(loginVerifyResponse:any)=>{
        if(loginVerifyResponse){
          request=request.clone({
            setHeaders:{
              Authorization:`Bearer ${loginVerifyResponse.token}`
            }
          })
        }
      }}
    )
    return next.handle(request);
  }
}
